module.exports = __webpack_public_path__ + "static/media/autosign-off.da670a74.svg";